export default {
    AUTH_ERROR: 'authError',
    SET_USER: 'setUser',
    SET_TEAM: 'setTeam',
    SET_BALANCE: 'setBalance',
    UPDATE_STATE: 'updateState',
    SET_LOADING_STATUS: 'setLoadingStatus',
}